import React, { useEffect, useRef, useState } from 'react'
import { styled } from '@mui/material';
import { Button, Input, Col, DatePicker, Divider, Flex, Modal, Row, Select, Table, Tag, Tooltip, Typography, Image, Alert, Checkbox, Tabs, Badge } from 'antd';
import dayjs from 'dayjs';
import AuthService from '../../Components/auth/AuthService';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import { locationTypes, reasonOptions, vehicleTypes } from '../../Components/common/Constants';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, DeleteFilled, ExportOutlined, InfoCircleOutlined, InfoCircleTwoTone, LockFilled, NumberOutlined, SnippetsOutlined, UnlockFilled } from '@ant-design/icons';
import ScanInput from '../Scan/ScanInput';
import ScanSelect from '../Scan/ScanSelect';
import { useSelector } from 'react-redux';
import { showMessage } from '../../Components/Utils/message';
import ProductScanSelect from '../Scan/ProductScanSelect';
import ProductInfoModal from '../../Components/Modals/ProductInfoModal';
import LockPickingButton from '../../Components/common/LockPickingButton';
import DetailsGrid from '../../Components/common/DetailsGrid';
import InputBox from '../../Components/common/InputBox';
import { env, wms_uploads_cdn } from '../../Components/config';
import { encodeId } from '../../Components/common/CommonFun';
import { getProductImageUrl } from '../../utils';
const Auth = new AuthService();
const DataSheet = styled('div')`
    .ant-select .ant-select-selector {
      border-bottom: 1px solidrgb(203, 195, 195);
      border-top: 0px !important;
      border-left: 0px;
      border-right: 0px;
      border-radius: 0px
    }
    .ant-input-disabled {
      background: none;
      color: black;
      fontWeight: 500;
    }
`;

const RoutePicking = () => {
  const { Option } = Select;
  const { Text, Title } = Typography;
  const { locations, products } = useSelector((state) => state?.AppState?.userCreds);

  const navigate = useNavigate();
  const layoutDispatch = useLoadingDispatch()
  const [deliveryDate, setDeliveryDate] = useState(dayjs());
  const [routes, setRoutes] = useState([]);
  const [selectedRouteDetails, setSelectedRouteDetails] = useState({
    id: null,
    vehicle_type: null,
    max_pallet: null,
    palet_id: null,
  });
  const [allRouteData, setAllRouteData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [routeStatus, setRouteStatus] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleProduct, setModalVisibleProduct] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedProductLocations, setSelectedProductLocations] = useState([]);
  const [itemTransactions, setItemTransactions] = useState([])
  const [pickRouteStock, setPickRouteStock] = useState({
    product: "",
    product_id: '',
    location: "",
    location_id: null,
    quantity: "",
    productText: '',
    locationText: '',
    productStatus: null,
    locationStatus: null,
    batch_id: null,
    batch_expiry: null,
    batch_quantity: '',
    batch_code: '',
    supplier_batch_code: '',
    remaining_quantity_check: false,
    fullPallet: false,
    fullPalletShow: false,
    remainQtyShow: false,
  });
  const [searchText, setSearchText] = useState('');
  const [selectedLocationsBatches, setSelectedLocationBatches] = useState([])
  const [routePickingFiles, setRoutePickingFiles] = useState([])
  const [routePickingNotes, setRoutePickingNotes] = useState('')
  const [currentProduct, setCurrentProduct] = useState(null)
  
  const imageUrl = getProductImageUrl(currentProduct);

  const productRef = useRef(null);
  useEffect(() => {
    if (modalVisible) {
      setTimeout(() => {
        productRef.current?.focus();
      }, 100);
    }
  }, [modalVisible]);

  const getLocationBatches = async (location_id, product_id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/location-batches?location_id=${location_id}&product_netsuite_id=${product_id}`);
      if (res?.ack) {
        const locationBatches = res?.location_batches || [];
        setSelectedLocationBatches(locationBatches)

        if (locationBatches.length === 1) {
          const singleBatch = locationBatches[0];
          const expiryDate = singleBatch?.expiry_date ? dayjs(singleBatch.expiry_date) : null;
          const daysToExpire = expiryDate ? expiryDate.diff(dayjs(), 'day') : null;

          if (daysToExpire === null || daysToExpire >= 0) {
            setPickRouteStock(prev => ({
              ...prev,
              batch_id: singleBatch.batch_id,
              batch_expiry: singleBatch.expiry_date,
              batch_quantity: singleBatch.stock_level,
              batch_code: singleBatch.batch_code,
              supplier_batch_code: singleBatch.supplier_batch_code
            }));
          }
        }
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
      hideLoading(layoutDispatch);
    } finally {
      hideLoading(layoutDispatch)
    }
  }


  const productValueChange = (value) => {
    setPickRouteStock({ ...pickRouteStock, product: value });
  };

  const productBlur = () => {
    if (!pickRouteStock?.product) {
      setPickRouteStock({ ...pickRouteStock, productStatus: 'error', productText: 'No Product Entered' })
      return;
    } else {
      const selectedProduct = products?.find((pro) => pro?.code == pickRouteStock?.product || pro?.barcode == pickRouteStock?.product);
      const productLocations = selectedProduct?.product_locations
        ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
        : [];
      const matchedLocations = locations.filter(location =>
        productLocations.includes(location.id)
      );
      setSelectedProductLocations(matchedLocations);

      if (selectedProduct) {
        if (selectedProduct?.code != selectedItem?.item_id) {
          setPickRouteStock({ ...pickRouteStock, productStatus: 'error', productText: 'Wrong product selected' })
        } else {

          setPickRouteStock({ ...pickRouteStock, product_id: selectedProduct?.netsuite_id, productStatus: 'success', productText: selectedProduct?.name })
        }
      } else {
        setPickRouteStock({ ...pickRouteStock, productStatus: 'error', productText: 'Product not found' })
      }

    }
  };

  const getProductLocations = async (product_id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/product-location/location-stock-by-product-batches?id=${product_id}`)
      if (res?.ack) {
        const resLocations = res?.product_location || [];

        const matchedLocations = locations
          ?.map(loc => {
            const matchedRes = resLocations.find(r => r.location_id === loc.id);
            if (matchedRes) {
              return {
                ...loc,
                quantity: matchedRes.quantity || 0, // push quantity from response
              };
            }
            return null;
          })
          .filter(Boolean) // remove unmatched
          .sort((a, b) => (b.is_picking || 0) - (a.is_picking || 0)); // sort by is_picking


        setSelectedProductLocations(matchedLocations || []);

        if (matchedLocations?.length === 1) {
          const singleLoc = matchedLocations[0];
          setPickRouteStock(prev => ({
            ...prev,
            location_id: singleLoc.id,
            batch_id: null,
            batch_code: '',
            batch_expiry: null,
            batch_quantity: '',
            supplier_batch_code: ''
          }));
          getLocationBatches(singleLoc.id, product_id);
        }
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      showMessage('error', 'Something went wrong');
    } finally {
      hideLoading(layoutDispatch);
    }
  }

  const productSelectValueChange = (val, isScanned) => {
    console.log('productSelectValueChange', val, isScanned);

    if (isScanned) {
      const selectedProduct = products?.find((pro) => pro?.code == val || pro?.barcode == val);
      const matchedProduct = selectedItem?.item_internal_id == selectedProduct?.netsuite_id ? true : false;
      const productLocations = selectedProduct?.product_locations
        ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
        : [];
      const matchedLocations = locations.filter(location =>
        productLocations.includes(location.id)
      );
      if (selectedProduct && matchedProduct) {
        setCurrentProduct(selectedProduct)
        setPickRouteStock(prev => ({ ...prev, product_id: selectedProduct?.netsuite_id, location_id: null, quantity: '', remaining_quantity_check: false, fullPallet: false }));
        // setSelectedProductLocations(matchedLocations);
        getProductLocations(selectedProduct?.netsuite_id);
      } else {
        setCurrentProduct(null)
        setPickRouteStock(prev => ({ ...prev, product_id: null, location_id: null, quantity: '', remaining_quantity_check: false, fullPallet: false }));
        setSelectedProductLocations([]);
        showMessage('error', 'Invalid product selected')
      }

    } else {
      const selectedProduct = products?.find((pro) => pro?.netsuite_id == val);
      console.log(selectedItem);

      const matchedProduct = selectedItem?.item_internal_id == selectedProduct?.netsuite_id ? true : false;
      const productLocations = selectedProduct?.product_locations
        ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
        : [];
      const matchedLocations = locations.filter(location =>
        productLocations.includes(location.id)
      );
      if (selectedProduct && matchedProduct) {
        setCurrentProduct(selectedProduct)
        setPickRouteStock(prev => ({ ...prev, product_id: val, location_id: null, quantity: '', remaining_quantity_check: false, fullPallet: false }));
        // setSelectedProductLocations(matchedLocations);
        getProductLocations(val);
      } else {
        setCurrentProduct(null)
        setPickRouteStock(prev => ({ ...prev, product_id: null, location_id: null, quantity: '', remaining_quantity_check: false, fullPallet: false }));
        setSelectedProductLocations([]);
        showMessage('error', 'Invalid product selected')
      }
    }
  };

  const locationSelectValueChange = (val, isScanned) => {
    console.log('locationSelectValueChange', val, isScanned);
    if (!pickRouteStock?.product_id) {
      showMessage('error', 'Please select a product first')
      setPickRouteStock({ ...pickRouteStock, location_id: null })
      return;
    }
    if (isScanned) {
      const matched = selectedProductLocations?.find(item => item.code === val);
      if (matched) {
        setPickRouteStock(prev => ({
          ...prev, location_id: matched.id,
          batch_id: null,
          batch_expiry: '',
          batch_quantity: '',
          batch_code: '',
          supplier_batch_code: ''
        }));
        getLocationBatches(matched?.id, pickRouteStock?.product_id)

      } else {
        showMessage('error', "No matching location");
      }
    } else {
      setPickRouteStock(prev => ({
        ...prev, location_id: val,
        batch_id: null,
        batch_expiry: '',
        batch_quantity: '',
        batch_code: '',
        supplier_batch_code: ''
      }));
      getLocationBatches(val, pickRouteStock?.product_id)

    }
  };

  const handleSelect = async (record) => {
    const selectedProduct = products?.find((pro) => pro?.code == record?.item_id);
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/route/route-picking-txn?route_status_id=${selectedRouteDetails?.id}&product_netsuite_id=${selectedProduct?.netsuite_id}`);
      if (res?.ack) {
        console.log('txns', res);
        const totalQuantityAdded = res?.route_data.reduce((sum, txn) => sum + (txn.quantity || 0), 0);
        const currentItemID = res?.route_data[0]?.product_netsuite_id;
        const updatedRemainingQty = record?.total_quantity - totalQuantityAdded;
        const updatedRecord = { ...record, remaining_quantity: updatedRemainingQty };
        const updatedData = filteredData.map(item => {
          if (item.item_internal_id === currentItemID) {
            return { ...item, remaining_quantity: updatedRemainingQty, picked_quantity: totalQuantityAdded };
          }
          return item;
        });
        // const selectedProduct = products?.find((pro) => pro?.netsuite_id == record?.item_internal_id);
        // const selectedProductCasesInPallets = selectedProduct?.cases_in_pallets
        // const capacityStaus = updatedRemainingQty >= selectedProductCasesInPallets ? true : false;
        // if (capacityStaus) {
        //   setPickRouteStock({ ...pickRouteStock, fullPalletShow: true, remainQtyShow: false })
        // } else {
        //   setPickRouteStock({ ...pickRouteStock, fullPalletShow: false, remainQtyShow: true })
        // }
        setSelectedItem(updatedRecord)
        setFilteredData(updatedData)
        setItemTransactions(res?.route_data)
        setModalVisible(true);

      } else {
        showMessage('error', res?.message);
        setItemTransactions([])
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
    }
    finally {
      hideLoading(layoutDispatch)
    }
  };


  const handleModalCancel = () => {
    setPickRouteStock({ product: "", product_id: '', location: "", location_id: null, quantity: "", productText: '', locationText: '', productStatus: null, locationStatus: null, batch_code: null, batch_expiry: null, batch_quantity: null, batch_id: null })
    setModalVisible(false);
    setItemTransactions([])
    setSelectedProductLocations([]);
  };

  const resetStates = () => {
    setRoutes([]);
    setSelectedRouteDetails({
      id: null,
      vehicle_type: null,
      max_pallet: null,
    })
    setAllRouteData([])
    setItemTransactions([])
    setFilteredData([])

  }


  const loadRoutes = async () => {
    resetStates()
    showLoading(layoutDispatch)
    try {
      const routeRes = await Auth.post(`/route/load-locked-routes`, {
        delivery_date: dayjs(deliveryDate).format("YYYY-MM-DD"),
      })
      if (routeRes.ack) setRoutes(routeRes.routes);
      else showMessage('error', routeRes.message);
    } catch (err) {
      showMessage('error', 'something went wrong')
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const getRouteData = async (routeID, route_status) => {
    console.log('route_status', route_status);
    
  const delivery = dayjs(deliveryDate).format("YYYY-MM-DD");
  showLoading(layoutDispatch);

  try {
    const res = await Auth.fetch(
      `/route/route-picking?route_status_id=${routeID}&delivery_date=${delivery}`
    );

    if (res?.ack) {
      const data = res.route_data || [];

      // Step 1: Calculate remaining quantity
      const updatedItems = data.map((item) => {
        const fulfilled = Number(item?.total_quantity) || 0;
        const dispatched = Number(item?.picked_quantity) || 0;

        return {
          ...item,
          remaining_quantity: fulfilled - dispatched,
        };
      });

      // Step 2: If route_status true and any remaining > 0, fetch remaining details
      if (route_status && updatedItems.some((i) => i.remaining_quantity > 0)) {

        try {
          const remainRes = await Auth.fetch(
            `/route/route-missing-picking?route_status_id=${routeID}&delivery_date=${delivery}`
          );

          if (remainRes?.ack) {
            const remainData = remainRes.missing_route_data || [];

            // Step 3: Merge by item_pallet_id
            const mergedItems = updatedItems.map((item) => {
              const matched = remainData.find(
                (r) => r.item_pallet_id === item.item_pallet_id
              );

              if (matched) {
                return {
                  ...item,
                  remaining_reason: matched.reason,
                };
              }

              return item;
            });

            setFilteredData(mergedItems);
            setAllRouteData(mergedItems);
          } else {
            setFilteredData(updatedItems);
            setAllRouteData(updatedItems);
          }
        } catch (err) {
          console.error("Remaining quantity fetch error:", err);
          setFilteredData(updatedItems);
          setAllRouteData(updatedItems);
        }
      } else {
        // no remaining or route_status false
        setFilteredData(updatedItems);
        setAllRouteData(updatedItems);
      }
    } else {
      setAllRouteData([]);
      setFilteredData([]);
      showMessage("error", res?.message);
    }
  } catch (err) {
    console.error(err);
    showMessage("error", "Something went wrong");
  } finally {
    hideLoading(layoutDispatch);
  }
};


  // const getRouteData = async (routeID) => {
  //   const delivery = dayjs(deliveryDate).format("YYYY-MM-DD");
  //   showLoading(layoutDispatch);
  //   try {
  //     const res = await Auth.fetch(`/route/route-picking?route_status_id=${routeID}&delivery_date=${delivery}`);
  //     if (res?.ack) {
  //       console.log(res);
  //       const data = res.route_data
  //       const updatedItems = data?.map((item) => {
  //         const fulfilled = Number(item?.total_quantity) || 0;
  //         const dispatched = Number(item?.picked_quantity) || 0;

  //         return {
  //           ...item,
  //           remaining_quantity: fulfilled - dispatched
  //         };
  //       });
  //       setFilteredData(updatedItems)
  //       setAllRouteData(updatedItems);

  //     } else {
  //       setAllRouteData([])
  //       setFilteredData([])
  //       showMessage('error', res?.message);

  //     }
  //   } catch (err) {
  //     console.log(err);
  //     showMessage('error', 'something went wrong')
  //   } finally {
  //     hideLoading(layoutDispatch)
  //   }
  // };

  const getPickingStatus = async (routeID) => {
    showLoading(layoutDispatch)
    try {
      const res = await Auth.fetch(`/route/route-status?route_status_id=${routeID}`);
      if (res?.ack) {
        const status = res?.route_status?.route_picked_by > 0 ? true : false;
        setRoutePickingNotes(res?.route_status?.route_picking_notes)
        setRoutePickingFiles(res?.route_status?.route_picking_files ? JSON.parse(res?.route_status?.route_picking_files) : [])
        setRouteStatus(status);
        if (status === true) {
          return true
        }else {
          return false
        };
      } else {
        setRouteStatus(false);
        return false
      }
    } catch (err) {
      showMessage('error', 'something went wrong');
      return false;
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  const routeChange = async (value) => {
    const selectedRoute = routes.find((route) => route.id === value);
    const palletCapacity = vehicleTypes.find((item) => item.id === selectedRoute?.vehicle_type);
    setSelectedRouteDetails({
      ...selectedRouteDetails,
      id: value,
      max_pallet: palletCapacity?.maxPallets,
      routeObj: selectedRoute,
    })
    const route_status = await getPickingStatus(value);
    getRouteData(value, route_status)
  };

  console.log(selectedRouteDetails);
  

  const changeRouteStatus = async (type) => {
    showLoading(layoutDispatch);
    const url = type === 1 ? '/route/unlock-route-picking' : '/route/lock-route-picking';
    const dataToSend = {
      route_status_id: selectedRouteDetails?.id,
    }
    try {
      const res = await Auth.fetch(url, {
        method: 'POST',
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        setRouteStatus(routeStatus => !routeStatus);
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      showMessage('error', 'Something went wrong');
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  const deleteTransaction = async (record) => {
    const dataToSend = {
      id: record?.id,
      product_netsuite_id: record?.product_netsuite_id
    }
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch('/route/route-picking-txn', {
        method: "DELETE",
        body: JSON.stringify(dataToSend)
      })
      if (res?.ack) {
        setModalVisible(false)
        setSelectedProductLocations([]);
        getPickingStatus(selectedRouteDetails?.id);
        getRouteData(selectedRouteDetails?.id)
      }
      else showMessage('error', res?.message)
    } catch (err) {
      showMessage('error', 'something went wrong')
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  const [selectedProductDetails, setSelectedProductDetails] = useState({
    totalStock: 0,
    code: '',
    name: '',
    productDetails: []
  })
  const handleModalCancelProduct = () => {
    setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, product: null, productDetails: [] });
    setModalVisibleProduct(false);
  }
  const handleInfoClick = async (record) => {
    const product = products?.find((item) => item?.code == record?.item_id);
    showLoading(layoutDispatch)
    try {

      const res = await Auth.fetch(`/product/product-details?id=${record?.item_internal_id}`)
      if (res?.ack) {
        if (res?.product_details.length > 0) {
          const totalStock = res.product_details.reduce((sum, item) => sum + (Number(item.stock_level) || 0), 0);
          setSelectedProductDetails({ ...selectedProductDetails, totalStock: totalStock, code: product?.code, name: product?.name, productDetails: res?.product_details });
          setModalVisibleProduct(true);
          hideLoading(layoutDispatch)

        } else {
          showMessage('error', 'No Details');
          hideLoading(layoutDispatch)
        }
      } else {
        setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: product?.code, name: product?.name, productDetails: [] });
        showMessage('error', res?.message)
        hideLoading(layoutDispatch)

      }

    } catch (error) {
      showMessage('error', 'something went wrong');
      hideLoading(layoutDispatch)
    }
  };

  useEffect(() => {
    const filteredData1 = allRouteData.filter((item) => {
      const product = products?.find(p => p.code === item.item_id);
      const itemName = product?.name?.toLowerCase() || '';
      const itemCode = product?.code?.toLowerCase() || '';
      const search = searchText.toLowerCase();
      return itemName.includes(search) || itemCode.includes(search);
    });
    setFilteredData(filteredData1)
  }, [searchText])

  const dataCol = [
    {
      title: "Sr No.",
      render: (_, __, index) => <span>{index + 1}</span>,
      width: 60,
    },
    {
      title: "Item",
      sorter: (a, b) => {
        const itemA = products?.find((item) => item.code == a?.item_id);
        const itemB = products?.find((item) => item.code == b?.item_id);
        const codeA = itemA?.code || '';
        const codeB = itemB?.code || '';
        return codeA.localeCompare(codeB);
      },
      showSorterTooltip: false,
      render(record) {
        return (
          <Flex gap={5} align="center">
            <Tooltip title={'Product Info'}>
              <InfoCircleTwoTone
                style={{ fontSize: '22px', cursor: 'pointer', padding: '2px' }}
                onClick={() => handleInfoClick(record)}
              />
            </Tooltip>
            <span>{`${record?.item_id} - ${record?.item_name}`}</span>
          </Flex>
        );
      },
    },
    {
      title: 'Location',
      sorter: (a, b) => {
        const locA = locations?.find(loc => loc.id === a?.location_id)?.code || a?.location || '';
        const locB = locations?.find(loc => loc.id === b?.location_id)?.code || b?.location || '';
        return locA.localeCompare(locB);
      },
      render: (record) => {
        const location = locations?.find(loc => loc.id === record?.location_id);
        return <span>{location?.code || record?.location || record?.bin || '-'}</span>;
      },
      align: 'center',
    },

    {
      title: 'Quantity',
      render(record) {
        return (
          <span>{record ? `${record?.total_quantity}` : 0}</span>
        );
      },
      align: 'center',

    },
    {
      title: 'Picked Qty',
      render(record) {
        return (
          <Tag color={Number(record?.picked_quantity) === Number(record?.total_quantity) ? 'green' : 'red'} style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.picked_quantity)?.toLocaleString() || 0} </Tag>
        );
      },
      align: 'center',
    },
    {
      title: 'Remaining Qty',
      render(record) {
        return <Tag color={record?.remaining_quantity > 0 ? 'red' : 'green'} style={{ fontSize: 16, fontWeight: 'bold' }}>{record?.remaining_quantity}</Tag>
      },
      align: 'center',

    },
    {
      title: "Action",
      align: "center",
      render: (record) => (
        <Tooltip title="Select Item">
          <ExportOutlined
            className="animated-select-icon"
            onClick={() => handleSelect(record)}
          />
        </Tooltip>
      ),
    }
  ];

  if (routeStatus) {
  const newColumn = {
    title: "Missing Reason", 
    align: "center",
    render: (record) => {
        let reason;
      if(record?.remaining_reason > 0 ) {
        const reasonItem = reasonOptions?.find((item)=> item?.value === record?.remaining_reason)
        reason = reasonItem?.label
      } else {
        reason = ''
      } 
    return (
      <span>
        {reason}
      </span>
    )
      
  },
  };

  // Insert before the Action column
  const actionIndex = dataCol.findIndex((col) => col.title === "Action");
  dataCol.splice(actionIndex, 0, newColumn);
}

  const itemTxnsCol = [
    {
      title: "Sr No.",
      render: (_, __, index) => <span>{index + 1}</span>,
      width: 60,
    },
    {
      title: 'Pickup Location',
      render(record) {
        const selectedlocation = locations?.find((loc) => loc?.id == record?.location_id)
        return (
          <>{selectedlocation?.code}</>
        );
      }
    },
    {
      title: 'Supplier Batch Code',
      dataIndex: 'supplier_batch_code',
      key: 'supplier_batch_code',
    },
    {
              title: "Expiry ",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{record?.expiry_date}</Tag>;
              }
            },
    {
      title: 'Quantity',
      render(record) {
        return (
          <>{Number(record?.quantity)?.toLocaleString() || 0} </>
        );
      }
    },
    {
      title: "User",
      render(record) {
        if (!record) return "";

        const user = record?.user_name || "";
        const helper = record?.helper_name || "";

        if (helper) {
          return (
            <>
              {helper}{" "}
              {user && (
                <Tooltip title={`${user}`}>
                  <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
                </Tooltip>
              )}
            </>
          );
        }

        return <>{user}</>;
      }
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => dayjs(date).format("DD-MM-YYYY HH:mm:ss"),
    },
    // {
    //   title: 'Action',
    //   align: "right",
    //   dataIndex: '',
    //   render(record) {
    //     return (
    //       <div style={{ display: "flex", justifyContent: "flex-end" }}>
    //         <DeleteFilled style={
    //           {
    //             fontSize: "25px",
    //             cursor: "pointer",
    //             color: "#cd1437",
    //           }} onClick={() => {
    //             Modal.confirm({
    //               title: 'Delete Transaction',
    //               centered: true,
    //               content: `Are you sure you want to delete this transaction?`,
    //               onOk: () => deleteTransaction(record),
    //               okText: 'Delete',
    //               cancelText: 'Cancel',
    //               width: 600,
    //               okButtonProps: { size: "large" },
    //               cancelButtonProps: { size: "large" },
    //             });
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];
  if (!routeStatus) {
    itemTxnsCol?.push({
      title: 'Action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <DeleteFilled style={
              {
                fontSize: "25px",
                cursor: "pointer",
                color: "#cd1437",
              }} onClick={() => {
                Modal.confirm({
                  title: 'Delete Transaction',
                  centered: true,
                  content: `Are you sure you want to delete this transaction?`,
                  onOk: () => deleteTransaction(record),
                  okText: 'Delete',
                  cancelText: 'Cancel',
                  width: 600,
                  okButtonProps: { size: "large" },
                  cancelButtonProps: { size: "large" },
                });
              }}
            />
          </div>
        );
      },
    })
  }

  const handleModalOk = async () => {
    if (!pickRouteStock?.product_id || !pickRouteStock?.location_id || !pickRouteStock?.quantity) {
      showMessage('error', 'Fill all required fields')
      return;
    }
    if (Number(pickRouteStock?.quantity) <= 0) return showMessage('error', 'Quantity must be greater than zero');
    const dataToSend = {
      product_netsuite_id: pickRouteStock?.product_id,
      location_id: pickRouteStock?.location_id,
      quantity: pickRouteStock?.quantity,
      route_status_id: selectedRouteDetails?.id,
      batch_id: pickRouteStock?.batch_id,
      supplier_batch_code: pickRouteStock?.supplier_batch_code,
      batch_code: pickRouteStock?.batch_code,
      expiry_date: pickRouteStock?.batch_expiry
    };
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch('/route/route-picking-txn', {
        method: 'PUT',
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        showMessage('success', res?.message)
        setFilteredData(prevItems =>
          prevItems.map(item => {
            if (item.item_id === selectedItem.item_id) {
              const newRem = selectedItem?.remaining_quantity - Number(pickRouteStock?.quantity)
              const newDispatchedQTY = Number(item.picked_quantity) + Number(pickRouteStock?.quantity)
              return { ...item, picked_quantity: newDispatchedQTY, remaining_quantity: newRem };
            }
            return item;
          })
        );
        setAllRouteData(prevItems =>
          prevItems.map(item => {
            if (item.item_id === selectedItem.item_id) {
              const newRem = selectedItem?.remaining_quantity - Number(pickRouteStock?.quantity)
              const newDispatchedQTY = Number(item.picked_quantity) + Number(pickRouteStock?.quantity)
              return { ...item, picked_quantity: newDispatchedQTY, remaining_quantity: newRem };
            }
            return item;
          })
        );
        setPickRouteStock({ product: "", product_id: '', location: "", location_id: null, quantity: "", productText: '', locationText: '', productStatus: null, locationStatus: null, batch_code: null, batch_expiry: null, batch_quantity: null, batch_id: null })
        setModalVisible(false);
        setSelectedProductLocations([]);
        setSelectedLocationBatches([])
        setItemTransactions([]);
      } else {
        showMessage('error', res?.message)
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
    }
    finally {
      hideLoading(layoutDispatch)
    }

  };

  // const allRemainingQty = allRouteData.reduce((acc, item) => {
  //   const total = item?.total_quantity ?? 0;
  //   const picked = item?.picked_quantity ?? 0;
  //   return acc + (total - picked);
  // }
  //   , 0);

  let allRemainingQty = 0;

  const UnfulflliedItems = allRouteData.reduce((acc, item) => {
    const total = Number(item?.total_quantity) ?? 0;
    const picked = Number(item?.picked_quantity) ?? 0;

    // Add to total remaining qty
    allRemainingQty += (total - picked);

    // If quantities are not equal, push to array
    if (total !== picked) {
      acc.push({
        item_id: item.item_id,
        item_name: item.item_name,
        total_quantity: total,
        picked_quantity: picked,
        item_internal_id: item?.item_internal_id,
        delivery_date: item?.delivery_date,
        route: item?.route,
        item_pallet_id: item?.item_pallet_id,

      });
    }

    return acc;
  }, []);

  console.log("All Remaining Qty:", allRemainingQty);
  console.log("Filtered Items:", allRouteData);


  console.log('routeStatus', routeStatus);
  const infoItem = [

    { label: 'Total Quantity', value: selectedItem?.total_quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} />, color: '#1677ff' },
    { label: 'Remaining Quantity', value: selectedItem?.remaining_quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} />, color: selectedItem?.remaining_quantity > 0 ? 'red' : '#1677ff' },
  ]


  const notesItem = {
    label: 'Notes',
    value: routePickingNotes,
    // onChange: (val) => setNotes(val),
    readOnly: true,
    type: 'notes',
    icon: <SnippetsOutlined style={{ color: "#1677ff" }} />
  };

  const frozenData = filteredData.filter(item => item.item_id?.toUpperCase().startsWith('F'));
  const chilledData = filteredData.filter(item => item.item_id?.toUpperCase().startsWith('C'));
  const ambientData = filteredData.filter(item => {
    const code = item.item_id?.toUpperCase();
    return !code?.startsWith('F') && !code?.startsWith('C');
  });



  return (
    <DataSheet>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: '10px' }}>
        <h3 style={{ margin: 0 }}>Route Picking</h3>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/stocks")}>Back</Button>
      </div>

      <Flex justify="space-between" align="center" gap={10} style={{ marginBottom: '16px' }} wrap>
        <Flex gap="small" flex={1} style={{ maxWidth: '300px' }}>
          <DatePicker
            format="DD-MM-YYYY"
            value={deliveryDate}
            onChange={(date) => setDeliveryDate(date ? dayjs(date, 'YYYY-MM-DD') : null)}
            placeholder="Select Date"
            style={{ flex: 1 }}
          />
          <Button type="primary" onClick={loadRoutes}>
            Load Routes
          </Button>
        </Flex>
      </Flex>

      {routes.length > 0 && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Select
              style={{
                width: "100%",
                margin: "2px",
                fontSize: '14px',
                marginTop: '15px'
              }}
              showSearch
              allowClear={false}
              value={selectedRouteDetails?.id}
              placeholder="Select Route"
              onChange={routeChange}
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
            >
              {routes.slice().sort((a, b) => a.title.localeCompare(b.title)).map((item) => (
                <Option key={item.id} value={item.id}>
                  {`${item.title} (${item.code}) - ${item.registration_number} - ${item.driver_name} `}
                </Option>
              ))}
            </Select>
          </Col>

        </Row>
      )}
      <Flex justify='space-between' align='center' gap={5} style={{ marginTop: 10 }} wrap>
        {allRouteData.length > 0 && (
          <Input
            placeholder="Search Item by name or code"
            allowClear
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 300 }}
          />
        )}
        {
          allRouteData?.length > 0 && (
            <Flex justify='end'>
              <Flex wrap gap={5}>
            {
                selectedRouteDetails?.routeObj?.wms_inventory_adjustment_id > 0 && (
                  <Tag color='blue' 
                  style={{ fontSize: '16px', padding: 5,fontWeight: 500 }}
                  onClick={()=> navigate(`/transaction-inventory/${encodeId(selectedRouteDetails?.routeObj?.wms_inventory_adjustment_id)}`)}
                  >Inventory Adjustment: {selectedRouteDetails?.routeObj?.wms_inventory_adjustment_code}</Tag>
                )
              }
              {
                routeStatus && (
                  <Tag color='red' style={{ fontSize: '18px', padding: 5 }}>Picking Locked</Tag>
                )
              }
              {routeStatus ? (
                <Button type='primary' icon={<UnlockFilled />} onClick={() => {
                  Modal.confirm({
                    title: 'Unlock Picking',
                    centered: true,
                    content: `Are you sure you to unlock picking for this route?`,
                    onOk: () => changeRouteStatus(1),
                    okText: 'Unlock',
                    cancelText: 'Cancel',
                    width: 600,
                    okButtonProps: { size: "large" },
                    cancelButtonProps: { size: "large" },
                  });
                }} >Unlock Picking</Button>
              ) : (
                // <Button danger icon={<LockFilled />}
                //   onClick={() => {
                //     Modal.confirm({
                //       title: 'Lock Picking',
                //       centered: true,
                //       content: <>
                //         {
                //           allRemainingQty > 0 && (
                //             <Text type='danger'>There are still {allRemainingQty} items remaining to be picked.</Text>
                //           )
                //         }
                //         {` Are you sure you to lock picking for this route?`}
                //       </>,
                //       onOk: () => changeRouteStatus(2),
                //       okText: 'Lock',
                //       cancelText: 'Cancel',
                //       width: 600,
                //       okButtonProps: { size: "large" },
                //       cancelButtonProps: { size: "large" },
                //     });
                //   }}
                // >Lock Picking</Button>
                <LockPickingButton
                  allRemainingQty={allRemainingQty}
                  filteredItems={UnfulflliedItems}
                  products={products}
                  selectedRouteDetails={selectedRouteDetails}
                  setRouteStatus={setRouteStatus}
                  routeChange={routeChange}
                />
              )}
              </Flex>    
            </Flex>)
        }
      </Flex>
      {allRouteData.length > 0 && (
        <div style={{ marginTop: 20 }}>
          {ambientData.length > 0 && (
            <div style={{ marginBottom: 30 }}>
              <Title level={4} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                Ambient <Badge count={ambientData.length} style={{ backgroundColor: '#52c41a' }} />
              </Title>
              <Table columns={dataCol} dataSource={ambientData} pagination={false} scroll={{ x: 'max-content' }} rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")} />
            </div>
          )}
          {chilledData.length > 0 && (
            <div style={{ marginBottom: 30 }}>
              <Title level={4} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                Chilled <Badge count={chilledData.length} style={{ backgroundColor: '#1890ff' }} />
              </Title>
              <Table columns={dataCol} dataSource={chilledData} pagination={false} scroll={{ x: 'max-content' }} rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")} />
            </div>
          )}
          {frozenData.length > 0 && (
            <div style={{ marginBottom: 30 }}>
              <Title level={4} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                Frozen <Badge count={frozenData.length} style={{ backgroundColor: '#722ed1' }} />
              </Title>
              <Table columns={dataCol} dataSource={frozenData} pagination={false} scroll={{ x: 'max-content' }} rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")} />
            </div>
          )}
        </div>
      )}

      {
        routeStatus && allRouteData?.length > 0 && (
          <>
            <Row>
              <Col span={12}>
                <InputBox inputItem={notesItem} inputType={'notes'} />
              </Col>
            </Row>
            <Image.PreviewGroup>
              {routePickingFiles?.length > 0 &&
                routePickingFiles?.map((item, index) => {
                  const imageUrl = `${wms_uploads_cdn}/${env}/route-picking/${selectedRouteDetails?.id}/${item.replace(/\+/g, '%2B')}`;
                  return (
                    <div key={index} style={{ marginRight: 10, display: 'inline-block' }}>
                      <Image
                        width={225}
                        height={125}
                        style={{ padding: 5, border: '1px solid lightgrey' }}
                        src={imageUrl}
                      />
                    </div>
                  );
                })}
            </Image.PreviewGroup>
          </>
        )
      }

      <Modal width={'70VW'} title={`Item Picking: ${selectedItem?.item_id} - ${selectedItem?.item_name}`} open={modalVisible}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: selectedItem?.remaining_quantity > 1 && 'none' } }}
        onCancel={handleModalCancel} >
        <Divider style={{ margin: '2px 2px' }} />
        <DetailsGrid infoItems={infoItem} />

        <>
          {
            (!routeStatus && Number(selectedItem?.remaining_quantity) > 0) && (
              <>
              <Row style={{ marginBottom: "10px" }}>
                 {pickRouteStock?.product_id && (
                  <Col 
                    xs={{ span: 24, order: 1 }}
                    md={{ span: 6, offset: 2, order: 2 }}
                    style={{ textAlign: "center", marginBottom: 16 }}
                  >
                    <Image 
                      src={imageUrl}
                      preview={false}
                      style={{
                        width: "100%",
                        maxWidth: 300,
                        height: "auto",
                        objectFit: "contain",
                      }}
                    />
                  </Col>
                )}
                <Col 
                  xs={{ span: 24, order: 2 }}
                  md={{ span: 14, order: 1 }}
                >
                <Row>
                  <Col style={{flex: 1}}>
                    <Text>Product</Text>
                    <ProductScanSelect onValueChange={productSelectValueChange} value={pickRouteStock?.product_id} options={products} placeholder="Product" size="large" length={'100%'} productRef={productRef} />
                  </Col>
                </Row>
                {
                  pickRouteStock?.product_id && (
                    <Row style={{ marginBottom: "10px" }}>
                      <Col style={{flex: 1}}>
                        <Text>Location</Text>
                        <ScanSelect onValueChange={locationSelectValueChange} value={pickRouteStock?.location_id} options={selectedProductLocations} placeholder="Location" size="large" length={'100%'} autoFocus />
                      </Col>
                    </Row>
                  )
                }
                {
                  pickRouteStock?.location_id > 0 && (
                    <Row>
                      <Col style={{flex: 1}}>
                        <Text>Location Batches</Text>
                        <Select
                          autoFocus
                          placeholder="Location Batches"
                          size="large"
                          showSearch
                          style={{ width: '100%' }}
                          filterOption={(input, option) =>
                            option?.label?.props?.children
                              ?.map?.((el) => (typeof el === 'string' ? el : ''))
                              .join(' ')
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          value={pickRouteStock?.batch_id}
                          onChange={(value) => {
                            const selectedBatch = selectedLocationsBatches?.find((item) => item.batch_id === value);
                            const selectedProduct = products?.find((pro) => pro?.netsuite_id == selectedItem?.item_internal_id);
                            const selectedProductCasesInPallets = selectedProduct?.cases_in_pallets
                            const capacityStaus = selectedBatch?.stock_level >= selectedProductCasesInPallets;
                           
                            const remainingQtyVal = selectedItem?.remaining_quantity > selectedProduct?.cases_in_pallets;
                            const fullCheck = capacityStaus && remainingQtyVal;
                            
                            const availableBatches = selectedLocationsBatches
                              ?.filter(b => b?.stock_level > 0 && b?.expiry_date) // only valid batches
                              ?.map(b => ({ ...b, expiryDateObj: dayjs(b.expiry_date) }));
                            const earliestBatch = availableBatches?.reduce((earliest, curr) =>
                              earliest?.expiryDateObj.isBefore(curr.expiryDateObj) ? earliest : curr
                            );
                            if (
                              earliestBatch &&
                              selectedBatch?.expiry_date &&
                              dayjs(selectedBatch.expiry_date).isAfter(earliestBatch.expiryDateObj)
                            ) {
                              Modal.confirm({
                                title: "Expiry Warning",
                                content: ` A batch with earlier expiry is still available. Do you still want to select this batch?`,
                                okText: "Yes, Continue",
                                cancelText: "No",
                                style: { width: 500 },
                                onOk: () => {
                                  setPickRouteStock({
                                    ...pickRouteStock,
                                    batch_id: value,
                                    fullPalletShow: fullCheck,
                                    remainQtyShow: fullCheck ? false : true,
                                    batch_expiry: selectedBatch?.expiry_date,
                                    batch_quantity: selectedBatch?.stock_level,
                                    batch_code: selectedBatch?.batch_code,
                                    supplier_batch_code: selectedBatch?.supplier_batch_code
                                  });
                                },
                              });
                              return
                            }
                            console.log('selectedProductCasesInPallets', selectedProductCasesInPallets);

                            
                            const expiryDate = selectedBatch?.expiry_date ? dayjs(selectedBatch.expiry_date) : null;
                            const daysToExpire = expiryDate ? expiryDate.diff(dayjs(), 'day') : null;
                            if (daysToExpire < 0) {
                              Modal.confirm({
                                title: "Expired Batch Selected",
                                content: `The batch you selected expired on ${expiryDate.format(
                                  "DD-MM-YYYY"
                                )}. Do you still want to use it?`,
                                okText: "Yes, Continue",
                                cancelText: "No",
                                onOk: () => {
                                  setPickRouteStock({
                                    ...pickRouteStock,
                                    batch_id: value,
                                    batch_expiry: selectedBatch?.expiry_date,
                                    batch_quantity: selectedBatch?.stock_level,
                                    batch_code: selectedBatch?.batch_code,
                                    supplier_batch_code: selectedBatch?.supplier_batch_code,
                                    fullPalletShow: fullCheck,
                                    remainQtyShow: fullCheck ? false : true,
                                  });
                                },
                              });
                              return;
                            }
                            setPickRouteStock({
                              ...pickRouteStock,
                              batch_id: value,
                              batch_expiry: selectedBatch?.expiry_date,
                              batch_quantity: selectedBatch?.stock_level,
                              batch_code: selectedBatch?.batch_code,
                              supplier_batch_code: selectedBatch?.supplier_batch_code,
                              fullPalletShow: fullCheck,
                              remainQtyShow: fullCheck ? false : true,
                            });
                          }}
                          optionLabelProp="label"
                        >
                          {selectedLocationsBatches.map((item) => {
                            const expiryDate = item?.expiry_date ? dayjs(item.expiry_date) : null;
                            const daysToExpire = expiryDate ? expiryDate.diff(dayjs(), 'day') : null;

                            const expiryColor =
                              !expiryDate ? 'default' :
                                daysToExpire < 0 ? 'red' :
                                  daysToExpire <= 30 ? 'orange' : 'green';
                            const isExpired = daysToExpire < 0;
                            const label = (
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                {item?.supplier_batch_code && (
                                  <Tag color="orange" style={{ margin: 0 }}>
                                    Batch: {item?.supplier_batch_code}
                                  </Tag>
                                )}
                                <Tag color="blue" style={{ margin: 0 }}>Qty: {item?.stock_level}</Tag>
                                <Tag color={expiryColor} style={{ margin: 0 }}>
                                  Exp: {expiryDate ? expiryDate.format('DD-MM-YYYY') : 'N/A'}
                                </Tag>
                              </div>
                            );

                            return (
                              <Option key={item.batch_id} value={item.batch_id} label={label} style={{ padding: 0 }} disabled={isExpired}>
                                <div
                                  style={{
                                    padding: '8px 12px',
                                    margin: '4px 0',
                                    border: '1px solid #f0f0f0',
                                    borderRadius: '8px',
                                    backgroundColor: '#fafafa',
                                  }}
                                >
                                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                    <Tag color="blue" style={{ fontWeight: 'bold', marginRight: 4 }}>
                                      Qty: {item?.stock_level}
                                    </Tag>
                                    <Tag color={expiryColor} style={{ fontSize: '13px', fontWeight: 500 }}>
                                      Exp: {expiryDate ? expiryDate.format('DD-MM-YYYY') : 'N/A'}
                                    </Tag>
                                  </div>
                                  {item?.supplier_batch_code && (
                                    <div style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center' }}>
                                      Batch Code: <span style={{ fontWeight: 500, marginLeft: 4 }}>{item?.supplier_batch_code}</span>
                                    </div>
                                  )}
                                </div>
                              </Option>
                            );
                          })}
                        </Select>
                      </Col>
                    </Row>
                  )
                }
                {
                  pickRouteStock?.batch_id && (
                    <Row >
                      <Col style={{ flex: 1 }}>
                        <Text>Quantity</Text>
                        <Flex align="center" gap="small" wrap>
                          <Input autoFocus size="large" type='number' value={pickRouteStock?.quantity}
                            onChange={(e) => {
                              // const newQty = e.target.value;
                              const raw = e.target.value;
                              const newQty = /^\d*$/.test(raw) ? raw.replace(/^0+(?=\d)/, "") : '1';
                              if (!pickRouteStock?.product_id) return showMessage('error', 'Select a product first');
                              if (!pickRouteStock?.location_id) return showMessage('error', 'Select a location first');
                              if (!pickRouteStock?.batch_id) return showMessage('error', 'Select a Batch Location first');
                              if (newQty > pickRouteStock?.batch_quantity) return showMessage('error', 'Quantity can not be greater than batch quantity');
                              if (newQty > Number(selectedItem?.remaining_quantity)) return showMessage('error', 'Quantity cannot be greater than remaining quantity!');
                              // if (newQty < 0) return showMessage('error', 'Quantity cannot be negative!');
                              setPickRouteStock({ ...pickRouteStock, quantity: newQty })
                            }
                            }
                            placeholder="Enter Quantity" />
                          {
                            pickRouteStock?.remainQtyShow && (
                              <Checkbox
                                checked={pickRouteStock?.remaining_quantity_check}
                                style={{ fontSize: '16px', width: '100%' }}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  const qtyRemaing = selectedItem?.remaining_quantity;

                                  if (isChecked) {
                                    if (!pickRouteStock?.product_id) {
                                      showMessage('error', 'Please select a product first');
                                      return;
                                    }
                                    if (!pickRouteStock?.location_id) {
                                      showMessage('error', 'Please select a location first ');
                                      return
                                    }
                                    if (!pickRouteStock?.batch_id) {
                                      showMessage('error', 'Please select a batch first ');
                                      return
                                    }
                                    if (qtyRemaing > pickRouteStock?.batch_quantity) {
                                      showMessage('error', 'remaining quantity exceeding batch quantity')
                                      return
                                    }

                                    setPickRouteStock({ ...pickRouteStock, quantity: qtyRemaing, remaining_quantity_check: isChecked });
                                  }
                                  else {
                                    setPickRouteStock({ ...pickRouteStock, quantity: '', remaining_quantity_check: false });
                                  }
                                }}
                              >
                                Remaining Quantity
                              </Checkbox>
                            )
                          }
                          {
                            pickRouteStock?.fullPalletShow && (
                              <Checkbox
                                checked={pickRouteStock?.fullPallet}
                                size="large"
                                style={{ marginTop: "10px" }}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  if (isChecked) {

                                    if (!pickRouteStock?.product_id) return showMessage("error", "Select product first");
                                    if (!pickRouteStock?.location_id) return showMessage("error", "Select location first");
                                    if (!pickRouteStock?.batch_id) return showMessage("error", "Select batch first");
                                    const selectedProduct = products?.find((pro) => pro?.netsuite_id == pickRouteStock?.product_id);
                                    const qtyRemaing = selectedItem?.remaining_quantity;
                                    const fullPalletQty = selectedProduct?.cases_in_pallets;

                                    if (fullPalletQty > Number(pickRouteStock?.batch_quantity)) return showMessage("error", "Exceeds batch quantity");
                                    if (fullPalletQty > qtyRemaing) {
                                      showMessage('error', 'Remaining quantity is less than pallet quantity')
                                      return;
                                    } else {
                                      setPickRouteStock({ ...pickRouteStock, quantity: fullPalletQty, fullPallet: e.target.checked })
                                    }
                                  } else {
                                    setPickRouteStock({ ...pickRouteStock, quantity: '', fullPallet: false });
                                  }

                                }
                                }
                              >
                                Full Pallet
                              </Checkbox>
                            )
                          }
                        </Flex>

                      </Col>
                    </Row>
                  )
                }
                </Col>
              </Row>

                <Flex justify='end' gap={5}>
                  <Button onClick={handleModalCancel}>Cancel</Button>
                  <Button type='primary' disabled={routeStatus} onClick={handleModalOk}>Save</Button>
                </Flex>
                <Divider />
              </>
            )
          }
          {
            itemTransactions.length > 0 && (
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                <Table columns={itemTxnsCol} dataSource={itemTransactions} pagination={false} scroll={{ x: 'max-content' }} rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")} />
              </div>
            )
          }
          {
            routeStatus && <Alert message='Route Picking Locked' type="info" showIcon />
          }
        </>

      </Modal>
      <ProductInfoModal
        visible={modalVisibleProduct}
        onCancel={handleModalCancelProduct}
        selectedItemDetails={selectedProductDetails}
        selectedItems={selectedProductDetails?.productDetails}
      // selectedRecord={selectedRecord}
      />

    </DataSheet>

  )
}

export default RoutePicking